import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  E_COM_SIGNUP,
  ACCOUNT_ID,
  ACH_ACCOUNT,
  ACH_ACCOUNT_NAME,
  ACH_BANK_NAME,
  ACH_ROUTING,
  AUTO_BILLING_ENROLL,
  AUTO_BILLING_LA,
  AUTO_BILLING_LA_END_DATE,
  AUTO_BILLING_LA_START_DATE,
  AUTO_BILLING_START_DATE,
  E_ACCOUNT_EMAIL,
  E_ACCOUNT_NAME,
  E_ACCOUNT_NO,
  E_ACCOUNT_PHONE,
  E_COM_START_DATE,
  PAYMENT_TYPE,
  ZELLE_URL,
} from "./consts";
import { useGetOwnerAccountDtlByOwnershipId } from "@/services";
import { useEffect, useState } from "react";
import { getRequiredFields } from "@/lib/utils";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { schema } from "./validations";

const useStep4 = () => {
  const [key, setKey] = useState<number>(Math.random() * 3);
  const form = useForm<any>({
    defaultValues: {
      [ACCOUNT_ID]: "",
      [PAYMENT_TYPE]: "",
      [ZELLE_URL]: undefined,
      [ACH_ROUTING]: undefined,
      [ACH_ACCOUNT]: undefined,
      [ACH_ACCOUNT_NAME]: undefined,
      [ACH_BANK_NAME]: undefined,
      [E_ACCOUNT_NO]: undefined,
      [E_ACCOUNT_NAME]: undefined,
      [E_ACCOUNT_EMAIL]: undefined,
      [E_ACCOUNT_PHONE]: undefined,
      [E_COM_SIGNUP]: false,
      [E_COM_START_DATE]: undefined,
      [AUTO_BILLING_ENROLL]: false,
      [AUTO_BILLING_START_DATE]: undefined,
      [AUTO_BILLING_LA]: false,
      [AUTO_BILLING_LA_START_DATE]: undefined,
      [AUTO_BILLING_LA_END_DATE]: undefined,
    },
    resolver: zodResolver(schema),
  });

  const {userData, communityData} = useSelector(
    (state: RootState) => state.currentData
  );
  const userId = userData?.userId;

  const userDataAction = useSelector(
    (state: RootState) => state.currentData.userDataAction
  );

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  // get owner account details
  const {
    data: ownerAccountDtlDetails,
    isLoading: isOwnerAccountDtlDetailsLoading,
    isRefetching: isOwnerAccountDtlDetailsRefetching,
  } = useGetOwnerAccountDtlByOwnershipId({
    id: userData?.userId as string,
    communityId: communityData?.communityId as string,
    queryParams: {
      enabled: !!userData?.userId && userDataAction != "add",
    },
  });

  useEffect(() => {
    if (ownerAccountDtlDetails) {
      form.reset({
        [ACCOUNT_ID]:
          ownerAccountDtlDetails?.data?.[ACCOUNT_ID]?.toString() || "",
        [PAYMENT_TYPE]:
          ownerAccountDtlDetails?.data?.[PAYMENT_TYPE]?.toString() || undefined,
        [ZELLE_URL]: ownerAccountDtlDetails?.data?.[ZELLE_URL] || undefined,
        [ACH_ROUTING]: ownerAccountDtlDetails?.data?.[ACH_ROUTING] || undefined,
        [ACH_ACCOUNT]: ownerAccountDtlDetails?.data?.[ACH_ACCOUNT] || undefined,
        [ACH_ACCOUNT_NAME]:
          ownerAccountDtlDetails?.data?.[ACH_ACCOUNT_NAME] || undefined,
        [ACH_BANK_NAME]:
          ownerAccountDtlDetails?.data?.[ACH_BANK_NAME] || undefined,
        [E_ACCOUNT_NO]:
          ownerAccountDtlDetails?.data?.[E_ACCOUNT_NO] || undefined,
        [E_ACCOUNT_NAME]:
          ownerAccountDtlDetails?.data?.[E_ACCOUNT_NAME] || undefined,
        [E_ACCOUNT_EMAIL]:
          ownerAccountDtlDetails?.data?.[E_ACCOUNT_EMAIL] || undefined,
        [E_ACCOUNT_PHONE]:
          ownerAccountDtlDetails?.data?.[E_ACCOUNT_PHONE] || undefined,
        [E_COM_SIGNUP]:
          ownerAccountDtlDetails?.data?.[E_COM_SIGNUP] || false,
        [E_COM_START_DATE]:
          ownerAccountDtlDetails?.data?.[E_COM_START_DATE] || undefined,
        [AUTO_BILLING_ENROLL]:
          ownerAccountDtlDetails?.data?.[AUTO_BILLING_ENROLL] || false,
        [AUTO_BILLING_START_DATE]:
          ownerAccountDtlDetails?.data?.[AUTO_BILLING_START_DATE] || undefined,
        [AUTO_BILLING_LA]:
          ownerAccountDtlDetails?.data?.[AUTO_BILLING_LA] || false,
        [AUTO_BILLING_LA_START_DATE]:
          ownerAccountDtlDetails?.data?.[AUTO_BILLING_LA_START_DATE] ||
          undefined,
        [AUTO_BILLING_LA_END_DATE]:
          ownerAccountDtlDetails?.data?.[AUTO_BILLING_LA_END_DATE] || undefined,
      });
      setKey(Math.random() * 3);
    }
  }, [ownerAccountDtlDetails]);

  return {
    form,
    requiredFields,
    isOwnerAccountDtlDetailsLoading,
    userId,
    ownerAccountDtlDetails,
    key,
    isOwnerAccountDtlDetailsRefetching,
  };
};

export default useStep4;
